import moment from "moment";

export class optencionPeriodos{

  static momentAbrev(){
    moment.updateLocale('es', {
      monthsShort: [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ]
    });
  }

  static getPeriodos(start_date: string, end_date: string): any[] {
    this.momentAbrev();

    const start = moment(start_date);
    const actual = moment();
    var end = moment(end_date);
    if(end.isAfter(actual) && start.isBefore(actual)){
      end = actual;
      end_date = actual.format('YYYY-MM-DD');
    }
    const meses = [];
    const periodos = [];
    var sel = false;
    while (start.isBefore(end)) {   
      const mes = {
        periodo: start.format("MMM-YY").toLowerCase(),
        mes: start.format("MMM").toLowerCase(),
        me: start.format("MM"),
        an: start.format("YYYY"),
        anio: start.format("YY"),
        check: moment().isSame(start, 'month') ? true : false,
        visible: true,
      };
      if(moment().isSame(start, 'month')){
        sel = true;
      }
      meses.push(mes);
      start.add(1, "month").startOf("month");
    }
    if(!sel && meses.length > 0){
      meses[meses.length-1].check = true;
    }

    const start2 = moment(start_date);
    const end2 = moment(end_date);

    while (start2.isBefore(end2)) {
      const m = meses.filter((m) => m.an === start2.format("YYYY") );
      const periodo = {
        anio: start2.format("YYYY"),
        visible: true,
        series: m,
      }
      periodos.push(periodo);
      start2.add(1, "year").startOf("year");
    }

    return periodos;
  }
}

export class functionsGoals{

  static getGoals( start_date: string, end_date: string, activitie ){
    optencionPeriodos.momentAbrev();

    const start = moment(start_date);
    const end = moment(end_date);

    const days = end.diff(start, 'days')+1;
    var goals = [];

    var planed = 0;
    while (start.isSameOrBefore(end)) {
      const endMonth = start.clone().endOf("month");
      var daysMonth;

      if( endMonth.isAfter(end) ){
        daysMonth = end.diff(start, 'days')+1;
      }else{
        daysMonth = endMonth.diff(start, 'days')+1;
      }
      
      planed += Number((daysMonth*100/days).toFixed(2));

      if( planed > 100 || start.diff(end, 'month') === 0 ){
        planed = 100;
      }
      const goal = {
        planned: Number(planed.toFixed(2)),
        executed: null,
        periodo: start.format("MMM-YY").toLowerCase(),
        year: start.year(),
        month: start.month()+1,
        id: '',
        activitieId: activitie,
      }

      goals.push(goal);

      start.add(1, "month").startOf("month");
    }

    return goals;
  }

}

export class functionsFormat{
  static formatearMoneda(num, dec, separadorM, separadorD){
    var separador =  separadorM;
    var sepDecimal = separadorD;
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + separador + '$2');
    }
    if(splitRight == "" && dec){
        splitRight = ".0";
    }
    if(!dec){
        splitRight = "";
    }
    return  splitLeft + splitRight;
  }
}

export class obtenerTamMax{
  static peso = 5;
  static mbMax = 1024*1000*this.peso;
  static errorMessage = 'El archivo no debe ser mayor a '+this.peso+' Mb';

  static getPeso(): Number{
    return this.mbMax;
  }
  
  static getTexto(): string{
    return this.errorMessage;
  }
}